import ArrSVG from '@public/icons/btn-arr.svg';
import Link from '@/shared/components/shared/Link';
import { useTypograf } from '@/shared/hooks/use-typograf';
import { ImageShape } from '@/shared/lib/types';
import { encodeUrl } from '@/shared/lib/utils/filter/chpu/encode-url';
import { formatDateString, getMonthNumberFromName } from '@/shared/lib/utils/formatDateString';

export interface ProgramCardSmallProps {
    date: string;
    title: string;
    description: string;
    dayId: number;
    publishedAt: string;
    endedAt?: string;
    image?: ImageShape;
}
interface Props {
    card: ProgramCardSmallProps;
}

function ProgramCard({ card }: Props) {
    const dateStart = card.publishedAt ? formatDateString(card.publishedAt) : undefined;
    const dateEnd = card.endedAt ? formatDateString(card.endedAt) : undefined;
    const isMultiDay = Boolean(dateEnd?.day);
    const href = isMultiDay ? '/program/' : encodeUrl('/program/', { day: card.dayId });

    const tpTitle = useTypograf(card.title);
    const tpDescription = useTypograf(card.description);

    return (
        <Link href={href} className="program-card">
            <div className="program-card-date">
                {dateStart && <div className="number-small">{dateStart.day}</div>}
                {dateEnd && dateEnd.day && <div className="number-small">-{dateEnd.day}</div>}
                {dateStart && <div className="text-s">.{getMonthNumberFromName(dateStart.month)}</div>}
            </div>
            <div className="program-card-text">
                {tpTitle && (
                    <div className="program-card-title text-xl" dangerouslySetInnerHTML={{ __html: tpTitle }} />
                )}
                {tpDescription && (
                    <div
                        className="program-card-description text-s"
                        dangerouslySetInnerHTML={{ __html: tpDescription }}
                    />
                )}
            </div>
            <div className="program-card-btn">
                <ArrSVG />
            </div>
        </Link>
    );
}

export default ProgramCard;
